export const CONTACT_US_NOTIFICATION = 'CONTACT_US_NOTIFICATION';
export const GET_USER_DESCRIPTION_LIST = 'GET_USER_DESCRIPTION_LIST';
export const GET_USER_DESCRIPTION_LIST_SUCCESS = 'GET_USER_DESCRIPTION_LIST_SUCCESS';